/**
  * user模块接口列表
  */

//  import base from './base.js'; // 导入接口域名列表
 import request from '@/api/http.js'; //请求对象
 
 const user = {
	
	/**
	 * 主账号登录地址
	 * 
	 * */
    login (params) {
        return request({url: `/admin_sign/signIn`,method: 'POST',data:params})
    },
    // 2026-10-05：复用服务端已有的只读校验，不重新登录、不延长令牌有效期。
    // 手动刷新时最多等待 5 秒；断网交给启动保护保留缓存，POST 避免复用过期的校验响应。
    validateToken () {
        return request({url: `/admin_sign/validateToken`,method: 'POST',timeout:5000})
    },
    modifyUserInfo (params) {
        return request({url: `/user/modifyUserInfo`,method: 'POST',data:params})
    },
    resetPassword (params) {
        return request({url: `/admin_m_user/resetPassword`,method: 'POST',data:params})
    },
    //付费修改用户信息
    modifyUserInfoByPaid (params) {
        return request({url: `/user/modifyUserInfoByPaid`,method: 'POST',data:params})
    },
  
 }
 
 export default user;
